import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import opacity from "react-element-popper/animations/opacity";
import "./style.css";
import moment from "moment";
import { convertUTCTimeToListingTime, getLocalListingTime } from '../../../../_metronic/helpers/convertTime.js'
import dayjs from "dayjs";
import { TimePickerModal } from "./TimePickerModal";

const BookingEditModalForm = ({
  setSelectedBookingId,
  fetchBooking,
  selectedBookingId,
  setOpenEditBookingModal,
  fetchBookingId
}) => {
  const [startDate, setStartDate] = useState();
  const [clockIn, setClockIn] = useState("");
  const [openTimePicker, setOpenTimePicker] = useState(false)

  const cancel = () => {
    setSelectedBookingId(null);
    setOpenEditBookingModal(false)
  };

  useEffect(() => {
    if (selectedBookingId) {
      setStartDate(dayjs(convertUTCTimeToListingTime(selectedBookingId?.start_date, selectedBookingId.timezone_id, 0, "YYYY-MM-DD")).toDate());
      setClockIn(selectedBookingId?.clock_in);
    }
  }, [selectedBookingId]);

  const EditBooking = () => {
    let date = dayjs(startDate).format('YYYY-MM-DD')
    axios.patch(`${process.env.REACT_APP_API_URL}/booking/${selectedBookingId.booking_id}`, {
      start_date: date,
      clock_in: clockIn,
    }).then(() => {
      toast.success(`Booking Information Updated For Booking Number #${selectedBookingId.booking_id}`);
      fetchBooking()
      fetchBookingId(selectedBookingId?.booking_id)
      setSelectedBookingId(null)
      setOpenEditBookingModal(false)
    }).catch((err) => {
      if (err && err.response && err.response?.data && err.response?.data?.message) {
        if (err.response.data.message === "Array is empty") {
          toast.error("Unable to move more than 1 day in past");
        } else {
          toast.error(err.response.data.message);
        }
      } else {
        toast.error("Technical Error, Please Try Again");
      }
    })
  }

  return (
    <>
      <div className="mt-4">
        <div className="fv-row mb-7">
          <label className="fw-bold fs-6 mb-2">Start Date</label>
          <DatePicker
            style={{
              width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              padding: "0.775rem 1rem",
              fontSize: "1.1rem",
              fontWeight: "500",
              lineHeight: "1.5",
              backgroundColor: "#f9f9f9",
              border: "1px solid #f9f9f9",
              color: "#5e6278",
              transition: "color 0.2s ease",
              height: "auto",
            }}
            containerStyle={{
              width: "100%",
            }}
            className="rmdp-mobile custom-calendar"
            calendarPosition="center"
            arrow={false}
            value={startDate}
            onChange={setStartDate}
            format="dddd MMM DD,YYYY"
            fixMainPosition={true}
            minDate={dayjs(getLocalListingTime(selectedBookingId?.time_offset)).format("YYYY-MM-DD")}
            animations={[opacity()]}
            placeholder="Select Date"
            weekDays={["S", "M", "T", "W", "T", "F", "S"]}
            scrollSensitive={false}
            hideOnScroll={false}
          />
        </div>
        <div className="fv-row mb-7">
          <label className="fw-bold fs-6 mb-2">Select Time</label>
          <input className="form-control form-control-solid mb-3 mb-lg-0"
            type="text"
            readOnly
            value={moment(clockIn, "HH:mm").format("hh:mm A")}
            onClick={() => setOpenTimePicker(true)}
          />
        </div>
      </div>
      <div className="text-center pt-15">
        <button
          onClick={() => cancel()}
          className="btn btn-light me-3"
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-main text-white"
          disabled={startDate === "" || clockIn === ""}
          onClick={EditBooking}
        >
          <span className="indicator-label">Edit Booking</span>
        </button>
      </div>
      {openTimePicker && <TimePickerModal onClose={() => setOpenTimePicker(false)} clockIn={clockIn} setClockIn={setClockIn} />}
    </>
  );
};

export { BookingEditModalForm };


export const hours = [
  { text: '00:00 AM', value: '00:00:00' },
  { text: '01:00 AM', value: '01:00:00' },
  { text: '02:00 AM', value: '02:00:00' },
  { text: '03:00 AM', value: '03:00:00' },
  { text: '04:00 AM', value: '04:00:00' },
  { text: '05:00 AM', value: '05:00:00' },
  { text: '06:00 AM', value: '06:00:00' },
  { text: '07:00 AM', value: '07:00:00' },
  { text: '08:00 AM', value: '08:00:00' },
  { text: '09:00 AM', value: '09:00:00' },
  { text: '10:00 AM', value: '10:00:00' },
  { text: '11:00 AM', value: '11:00:00' },
  { text: '12:00 PM', value: '12:00:00' },
  { text: '01:00 PM', value: '13:00:00' },
  { text: '02:00 PM', value: '14:00:00' },
  { text: '03:00 PM', value: '15:00:00' },
  { text: '04:00 PM', value: '16:00:00' },
  { text: '05:00 PM', value: '17:00:00' },
  { text: '06:00 PM', value: '18:00:00' },
  { text: '07:00 PM', value: '19:00:00' },
  { text: '08:00 PM', value: '20:00:00' },
  { text: '09:00 PM', value: '21:00:00' },
  { text: '10:00 PM', value: '22:00:00' },
  { text: '11:00 PM', value: '23:00:00' },
  { text: '11:59 PM', value: '23:59:00' },
];